$(function() {
$('.product-review-main').slick({
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    centerMode: false,
    mobileFirst: true,
    responsive: [
       {
        breakpoint: 749,
        settings: {
        slidesToShow: 2,
        slidesToScroll:1
        }
       },
        {
            breakpoint: 989,
            settings: "unslick"
        }
    ]
});

$('.hiw-review-main').slick({
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    centerMode: false,
    mobileFirst: true,
    responsive: [
        
        {
            breakpoint: 749,
            settings: "unslick"
        }
    ]
});

$('.show-slick-mobile').slick({
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    adaptiveHeight: true,
    arrows: false,
    centerMode: false,
    mobileFirst: true,
    responsive: [
        
        {
            breakpoint: 749,
            settings: "unslick"
        }
    ]
});
  
  $(window).on('resize', function() {
    //console.log('resize');
        $('.review-main, .product-review-main, .feature-point, .hiw-review-main, .mul-col-main').slick('resize');
    });
});

$('.review-button, .product-page-review-button').on('click', function() {
    $('.review-main, .product-review-main').slick('slickPause');
    $('.review-main, .product-review-main').addClass('slider-unseter')
});

$('.popop-overlay, .popup-close').on('click', function() {
    $('.review-main, .product-review-main').slick('slickPlay');
    $('.review-main, .product-review-main').removeClass('slider-unseter')
});


$(function() {
$('.blog_slider--mobile').slick({
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    centerMode: false,
    adaptiveHeight: true,
    // mobileFirst: true,
    responsive: [
        {
          breakpoint: 9999999999,
          settings: "unslick"
        },
        {
          breakpoint: 992,
          settings: "slick"
        },
      {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
      }
    ]
});
  $(window).on('resize', function() {
        $('.blog_slider--mobile').slick('resize');
    });
});



$('.brand-main').slick({
  dots: false,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  speed: 6000,
  cssEase: 'linear',
  pauseOnHover: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: false,
  centerMode: true,
  centerPadding: '80px',
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(window).on('resize', function() {
      $('.brand-main').slick('resize');
});

$('.icon-text-main').slick({
  dots: false,
  autoplay: false,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  autoplaySpeed: 0,
  speed: 10000,
  cssEase: 'linear',
  pauseOnHover: false,
  variableWidth: true,
  responsive: [
     {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$(window).on('resize', function() {
      $('.icon-text-main').slick('resize');
});

$(document).ready(function(){
 
  
  $(document).on('click','button', function () {
   function cartCount(){ $.getJSON('/cart.js', function(cart) {
     $(".cart-count-bubble > span").html(cart.item_count); 
     if(cart.item_count == 0){
      $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span aria-hidden="true">0</span><span class="visually-hidden">0 items</span></div>');
     }
   });}
  setTimeout(function () {
    cartCount();
  },1000)
  })


  
 $(".popop-overlay, .popup-close").click(function(){
    var url = $(".pop-up-video-section iframe").attr('src','');
    // console.log('hide:' +''+ url);
   $('body,html').removeClass('overflow-hidden');
    $(".pop-up-video-section .popup-video").html('');
    $(".popop-overlay, .pop-up-video-section").hide();
  });
  
  $(".review-button, .video-label-bt").click(function(Event){
    Event.preventDefault();
    var video_data = $(this).parents('.reviewer-name-button').find(".cdk_video_data").html();
    // console.log(video_data);
    $('.pop-up-video-section .popup-video').html(video_data);
    $(".popop-overlay, .pop-up-video-section").show();
    $('body,html').addClass('overflow-hidden');
  });

  
});

$(document).ready(function(){ 

$(".blog-catg-button").click(function(){
  console.log("click");
  $(".blog-catg-list").slideToggle();
});

  
$(function() {
  
  $('.main-product-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    fade: true,
    asNavFor: '.main-product-slider-nav'
    
  });
 
    $('.main-product-slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 6,
    dots: false,
    infinite: false,
    centerMode: false,
    mobileFirst: true,
    asNavFor: '.main-product-slider',
    prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    responsive: [
    {
        breakpoint: 989,
        settings: "unslick"
    }
  ]
  });

  $(window).on('resize', function() {
      $('.main-product-slider-nav, .main-product-slider').slick('resize');
  });

  $('.slide-arrow.next-arrow').click(function(){
    $(".main-product-slider").slick('slickNext');
  });
  
  $('.slide-arrow.prev-arrow').click(function(){
      $(".main-product-slider").slick('slickPrev');
  });
  
  $(document).on('click', '.main-product-slider-nav li', function(){
  var slide_number = $(this).index();
  $('.main-product-slider').slick('slickGoTo', slide_number);
  });
  
});

var deviceWidth = $(window).width();
  if(deviceWidth < 500){
  $(document).on('click', '.mobile-screen-cart', function () {
    console.log('click::'+deviceWidth);
    setTimeout(function () {
      // $("html, body").animate({ scrollTop: "0" });
    },1000);
  })
}

  $(".menu-links").hover(function(){
      $(this).parents('.list-menu').addClass('list-active');
      $(this).siblings('.menu-links').removeClass('menu-active')
      $(this).addClass('menu-active');
  });

  // Currency selector code
 $('form.selectors-form .disclosure-list').change(function(){
    var thisValue = $(this).val(); var currentThis = $(this);
    console.log('thisValue :: '+thisValue);
    $(this).parents('.disclosure').find('#CurrencySelector').val(thisValue);
    setTimeout(function(){ currentThis.parents('form').submit();  },200);
  });

$(".disclosure-list__item").click(function() {
    var currencyForm = $('form.selectors-form')
    var thisValue = $(this).attr('currencyCode');
    console.log('thisValue :: '+ thisValue);
    currencyForm.find('#CurrencySelector').val(thisValue);
    setTimeout(function(){ currencyForm.submit();  }, 200);
});

$(document).ready(function() {
  $(".disclosure-list__item.remove_item").remove();
})

  
  window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show_currencies')) {
        openDropdown.classList.remove('show_currencies');
      }
    }
  }
}

// var header = $(".add-cart-bt-sticky");
// $(window).scroll(function() {    
//   var scroll = $(window).scrollTop();
//      if (scroll >= 1050) {
//         header.addClass("fixed");
//         $("#chat-button").addClass("move-widget");
//       } else {
//         header.removeClass("fixed");
//       }

//   if (scroll >= 38) {
//         $('body').addClass("cart-height"); 
//       } else {
//         $('body').removeClass("cart-height");
//         $("body").removeClass('cdk_cart_scroll_down');
//       }
//   //console.log("scroll:"+scroll);
// });

// var lastScrollTop = 0;
// $(window).scroll(function(event){
//    var st = $(this).scrollTop();
//    if (st > lastScrollTop){
//        // downscroll code
//      $(".add-cart-bt-sticky").addClass('showAct_bar');
//      $("body").addClass('cdk_cart_scroll_down');
//    } else {
//       // upscroll code
//      $(".add-cart-bt-sticky").removeClass('showAct_bar');
//      $("body").removeClass('cdk_cart_scroll_down');
//      $("#chat-button").removeClass("move-widget");
//    }
//    lastScrollTop = st;
// });

  
$(document).on('click','.mobile-screen-cart .icon-cart-new', function(){
  $(this).hide();
  $('.mobile-screen-cart .mobile-drawer-close').show();
  $('.cart-count-bubble').hide();
  $('details#Details-menu-drawer-container').removeAttr('open');
  $('details#Details-menu-drawer-container .header__icon').attr('aria-expanded','false');
  $('cart-drawer').show();
  $('.drawer').addClass('active');
   $('body').addClass('overflow-hidden');
  $('html').addClass('mobile-overflow-hidden');
});

$('.mobile-screen-cart .mobile-drawer-close').on('click', function(){
  $(this).hide();
  $('.cart-count-bubble').show();
  $('.mobile-screen-cart .icon-cart-new').show();
  $('.drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
  $('html').removeClass('mobile-overflow-hidden');
  $(".add-cart-bt-sticky").removeClass('add-cart-bt-sticky-hide');
});
$(document).on('click','details#Details-menu-drawer-container:not([open])', function(){
  $('.cart-count-bubble').show();
   $('body').removeClass('cartOpen');
  $('.mobile-screen-cart .mobile-drawer-close').hide();
   $('.mobile-screen-cart .icon-cart-new').show();
  $('.drawer').removeClass('active');
   $('body').removeClass('overflow-hidden');
  $('html').removeClass('mobile-overflow-hidden');
});

  
$('.product-bt-sticky').on('click', function(){
  setTimeout(function () {
    $(".add-cart-bt-sticky").addClass('add-cart-bt-sticky-hide');
    $('body').addClass('cartOpen');
    $('.drawer').addClass('drawer-down active');    
  },600)
});
  
$(".header .header__icon--cart").click(function(){
  $("cart-drawer").show();
  $('body').toggleClass('cartOpen');
});

});

$(document).on('click','#CartDrawer-Overlay', function () {
 $('body, html').removeClass('overflow-hidden');
})

function removeClass() {
  $('body').removeClass('cartOpen');
  $('cart-drawer').removeClass('drawer-down');
  $('.mobile-screen-cart + .cart-count-bubble').show();
   $('body').removeClass('overflow-hidden');
  $('html').removeClass('mobile-overflow-hidden');
  $('.mobile-screen-cart .mobile-drawer-close').hide();
  $('.mobile-screen-cart .icon-cart-new').show();
  $('.drawer').removeClass('active');
  $(".add-cart-bt-sticky").removeClass('add-cart-bt-sticky-hide');
  $('html').removeClass('overflow-hidden');
};

$(document).on('click' , '.clearpay-paragraph a.clearpay-link' , function(){
  $('#clearpay-popup-wrapper').show();
});
$(document).on('click' , '.afCloseBtn, #clearpay-popup-outer' , function(){
  $('#clearpay-popup-wrapper').hide();
});

$(document).on('click' , '.thumbnail-slider button.slide-arrow.next-arrow' , function(){
  var Thum_index = $('.thumbnail-slider .main-product-slider-nav .thumb_currentSlide').index()+1;
  var scrollTopVal = 104 * Thum_index;
  $('.thumbnail-slider .main-product-slider-nav').animate({ scrollTop: scrollTopVal });
  $('.thumbnail-slider .main-product-slider-nav .thumbnail-list__item').removeClass('thumb_currentSlide');
  $('.thumbnail-slider .main-product-slider-nav .thumbnail-list__item').eq(Thum_index).addClass('thumb_currentSlide');
});

$(document).on('click' , '.thumbnail-slider .main-product-slider-nav .thumbnail-list__item' , function(){
  $('.thumbnail-slider .main-product-slider-nav .thumbnail-list__item').removeClass('thumb_currentSlide');
  $(this).addClass('thumb_currentSlide');
});


$(document).ready(function() {
var checkExist = setInterval(function() {
        if ($('#unwevering').length) {

    $(window).scroll(startCounter);

    function startCounter() {
        var DistanceFromTop = $('#unwevering').offset().top - $(window).scrollTop();
        var CdkscreenSize = $(window).width();
        if (CdkscreenSize > 1500) {
            if (DistanceFromTop < 650 && DistanceFromTop != 'undefined') {
                $(window).off("scroll", startCounter);
                $('.cdk_count_statics').each(function() {
                    var $this = $(this).find('.counter');
                    $({ Counter: 1 }).animate({ Counter: $this.text() }, {
                        duration: 4000,
                        easing: 'swing',
                        step: function() {
                            $this.text(Math.ceil(this.Counter));
                        }
                    });
                });
            }
        } else {
            if (DistanceFromTop < 600 && DistanceFromTop != 'undefined') {
                $(window).off("scroll", startCounter);
                $('.cdk_count_statics').each(function() {
                    var $this = $(this).find('.counter');
                    $({ Counter: 1 }).animate({ Counter: $this.text() }, {
                        duration: 4000,
                        easing: 'swing',
                        step: function() {
                            $this.text(Math.ceil(this.Counter));
                        }
                    });
                });
            }
        }
      

      }
        clearInterval(checkExist);
    }
  }, 1000);

 // Image zoom plugin code 
  var devWidth = $(window).width();
  console.log('devWidth'+devWidth);
  if(devWidth > 974){
    var zoomImages = $('.zoom-images'); 
    zoomImages.each(function() {
        $(this).imageZoom();
    });
    }
});
 
$('.show-slick').slick({
  lazyLoad: 'ondemand',
  dots: true,
  autoplay: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  adaptiveHeight: true,
  cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  responsive: [
     {
      breakpoint: 749,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});
  $(window).on('resize', function() {
        console.log('resize');
    setTimeout(function () {
          $('.feature-main').slick('resize');
        },500)
        
    });

$('.review-main').slick({
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    centerMode: false,
    adaptiveHeight: true,
    // mobileFirst: true,
    responsive: [
        {
          breakpoint: 9999999999,
          settings: "unslick"
        },
        {
          breakpoint: 992,
          settings: "slick"
        },
      {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
      }
    ]
});

$('.mul-col-main').slick({
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    centerMode: false,
    // mobileFirst: true,
    responsive: [
        {
          breakpoint: 9999999999,
          settings: "unslick"
        },
        {
          breakpoint: 992,
          settings: "slick"
        },
      {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
      }
    ]
});


$(document).ready(function() {
    $(".video__controls").click(function() {
      var videoFile = $(this).next('video');
        if ($(videoFile).get(0).paused) {
            $(videoFile).trigger('play');
            $(".video__controls .video_pay_btn").fadeOut(500);
        } else {
            $(videoFile).trigger('pause');
            $(".video__controls .video_pay_btn").fadeIn(500);
        }
    });
    
  $('.main-product .product__media-gallery .slider-mobile-gutter .thumbnail-list__item .thumb__video_btn').click(function(){
    $('.video__controls').next('video').trigger('play');
    $(".video__controls .video_pay_btn").fadeOut(500);
  })
  
    // On slide change, pause video
    $('.product__media-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
        if(window.matchMedia("(max-width: 767px)").matches){
           $(".video__controls .video_pay_btn").fadeIn(500);
           $('video').each(function() {
              $(this).get(0).pause();
           });
        }
      });
});

$('.announcement-slider').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false
});


$('.bundle__slider').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow-bundle"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow-bundle"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
});
